/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable import/no-cycle */
import React, { useState, useEffect, useRef } from 'react';
import {
  GridComponent,
  Inject,
  ColumnsDirective,
  ColumnDirective,
  Search,
  Page,
  Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize,
} from '@syncfusion/ej2-react-grids';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { DialogUtility } from '@syncfusion/ej2-react-popups';

import axios from 'axios';
import { useStateContext } from '../contexts/ContextProvider';
import Header from './Header';
import '../pages/Zackat.css';

function DuressEvents({ props }) {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const {
    zRenderMode,
    duressLimitPreference,
    setDuressLimitPreference,
  } = useStateContext();
  const grid = useRef(null);
  const del = { text: 'Delete', tooltipText: 'Delete Duress', prefixIcon: 'e-delete-2', id: 'delete' };
  const toolbarOptions = [del];

  const [searchParams] = useSearchParams();
  let associateid = searchParams.get('id');
  let assocId = searchParams.get('name');
  let associatename = 'Duress Events for ';
  let device = searchParams.get('device');
  let myfont = '';
  let source = 'zackat-div';
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [duressEventLimit, setDuressEventLimit] = useState(localStorage.getItem('duressEventLimit') || 14);

  const limitTemplate = () => (
    <div className="e-toolbar-left">
      <input type="text" id="limit" placeholder="Limit number of days" defaultValue={duressEventLimit} className="custom-toolbar-input" />
      <button type="button" className="e-btn e-success e-outline" onClick={() => { const lim = document.getElementById('limit').value; setData([]); setDuressEventLimit(lim); localStorage.setItem('duressEventLimit', Number(lim), setDuressLimitPreference(!duressLimitPreference)); }}>Limit Days</button>
    </div>
  );

  if (props && props._id && props._id.length > 0 && props.name && props.name.length > 0) {
    associateid = props._id;
    assocId = props.name;
    device = props.device;
    associatename += props.name;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (props && props._id && props._id.length > 0 && props.device.length > 0) {
    associateid = ''; // props.associateid;
    assocId = props.device;
    device = props.device;
    associatename += props.device;
    source = props.source;
    myfont = 'e-mygrid';
  } else if (associateid) {
    associatename += `${assocId}`;
  } else {
    associatename += `${device}`;
    associateid = null;
  }

  const editing = {
    allowDeleting: true,
    allowEditing: false,
    showDeleteConfirmDialog: true,
    mode: 'Dialog',
  };
  const { REACT_APP_API_ENDPOINT } = process.env;
  const startPCM = (e) => {
    const audio = new Audio(`${REACT_APP_API_ENDPOINT}/duressdown?photo=${e}`);
    audio.play();
  };
  const actionComplete = (args) => {
    if (args.requestType === 'delete') {
      if (args.data) {
        const editedData = args.data;
        // Assign the OrganizationID for the Audit Trail
        editedData[0].organizationid = props.organizationid;
        // Here you can send the updated data to your server using AJAX call
        fetch(`${REACT_APP_API_ENDPOINT}/duress_events?duressId=${editedData[0]._id}`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `JWTToken ${usr.token}`,
          },
          body: JSON.stringify(editedData[0]),
        })
          .then((response) => response.json())
          .then(() => {
            // The added/edited data will be saved in the Grid
            // The default edit operation is cancelled
            DialogUtility.alert('Duress has been removed!');
          })
          .catch((error) => {
            DialogUtility.alert(`An error has occured during Delete! ${error.message}`);
          });
      }
    }
  };
  const recordPlayTemplate = (dprops) => (
    <div>
      {/* <input type="button" name="download" id={dprops.filename} value="&#x23F5;"  onClick={startPCM} /> */}
      <ButtonComponent cssClass="e-large" iconCss="e-icons e-play" style={{ float: 'left' }} id={dprops._id} onClick={() => { startPCM(dprops.filename); }}>Play</ButtonComponent>
    </div>
  );

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      if (device !== null) {
        const query = Object.entries(usr)
          .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
          .join('&');
        let url = `${REACT_APP_API_ENDPOINT}/duress_events?${query}&associateid=${associateid}&device=${device}&limit=${duressEventLimit}`;
        if (!associateid || associateid.length === 0) {
          url = `${REACT_APP_API_ENDPOINT}/duress_events?${query}&device=${device}&limit=${duressEventLimit}`;
        }
        await axios({
          url,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.data) {
              setData(response.data);
            }
            setLoading(false);
          })
          .catch((error) => {
            console.error(error.message);
            setLoading(false);
          });
      } else {
        await axios({
          url: `${REACT_APP_API_ENDPOINT}/duress_events?associateid=${associateid}&limit=${duressEventLimit}`,
          method: 'get',
          headers: {
            Authorization: `JWTToken ${usr.token}`,
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            setData(response.data);
            setLoading(false);
          })
          .catch((error) => {
            console.error(error.message);
            setLoading(false);
          });
      }
    };
    fetchData();
  }, [associateid, duressEventLimit]);
  const clickHandler = (args) => {
    if (grid && grid.current && args.item.properties.text === 'Delete') {
      const selectedRow = grid.current.getSelectedRecords()[0];
      grid.current.deleteRecord(selectedRow);
    }
  };
  if (loading) {
    return <p>Loading... </p>;
  }
  const wrapSettings = { wrapMode: 'Both' };
  const FilterOptions = {
    type: 'Menu',
  };
  return (
    <div
      className={source === 'controlpanel' ? 'm-1 md:m-1 mt-2 p-2 md:p-2 rounded-3xl' : 'm-2 md:m-10 mt-24 p-2 md:p-10 bg-white rounded-3xl zackat-div'}
    >
      <Header category="" title={associatename} />
      <div id="container">
        <ToolbarComponent id="toolbar">
          <ItemsDirective>
            <ItemDirective template={limitTemplate} disabled={false} />
            <ItemDirective type="Separator" />
          </ItemsDirective>
        </ToolbarComponent>
      </div>
      <div className="e-adaptive-demo e-bigger">
        <div className="e-mobile-layout">
          <div className="e-mobile-content">
            <GridComponent
              dataSource={data}
              className={myfont}
              allowPaging
              width="100%"
              allowSorting
              allowExcelExport
              allowPdfExport
              editSettings={editing}
              toolbar={toolbarOptions}
              cssClass="custom-grid-toolbar"
              toolbarClick={clickHandler}
              enableHover={false}
              actionComplete={actionComplete}
              pageSettings={{ pageSize: 25, pageCount: 10 }}
              allowResizing
              allowFiltering
              filterSettings={FilterOptions}
              showColumnChooser
              allowTextWrap
              textWrapSettings={wrapSettings}
              ref={grid}
              enableAdaptiveUI
              rowRenderingMode={zRenderMode}
              enableAltRow
            >
              <ColumnsDirective>
                {/* eslint-disable-next-line react/jsx-props-no-spreading */}
                <ColumnDirective
                  field="_id"
                  headerText="ID"
                  template={recordPlayTemplate}
                  width="100"
                  isPrimaryKey
                  visible
                />
                <ColumnDirective
                  field="metadata.device"
                  headerText="Device"
                  width="150"
                  visible
                />
                <ColumnDirective
                  field="uploadDate"
                  headerText="Timestamp"
                  width="150"
                  visible
                />
                <ColumnDirective
                  field="length"
                  headerText="Size"
                  width="150"
                  visible
                />
              </ColumnsDirective>
              <Inject services={[Search, Page, Selection, Toolbar, Edit, Sort, Filter, ColumnChooser, Resize]} />
            </GridComponent>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DuressEvents;
